export function displayValue(value) {
  if (value === null || value === undefined || String(value).trim() === "") {
    return "-";
  }
  return value;
}

export function hasStaffImage(item) {
  const image = String(item?.image ?? "").trim();
  console.log(image, item);
  return image;
}

export function formatStaffMobile(item) {
  const mobile = String(item?.mobile ?? "").trim();
  if (!mobile) return "-";
  const code = String(item?.country_code ?? "").trim();
  return code ? `+${code} ${mobile}` : mobile;
}

export function translateDayName(day, t) {
  if (!day) return "";
  const key =
    String(day).charAt(0).toUpperCase() + String(day).slice(1).toLowerCase();
  const translated = t(`days.${key}`);
  return translated !== `days.${key}` ? translated : day;
}

export function formatWorkSchedule(schedule, t) {
  if (!Array.isArray(schedule) || !schedule.length) return [];

  return schedule
    .map((entry) => {
      const dayLabel = translateDayName(entry.day, t);
      const times = Array.isArray(entry.times) ? entry.times : [];

      if (!times.length) {
        return dayLabel;
      }

      const slots = times
        .map((slot) => {
          const from = slot.from || slot.start_time || "";
          const to = slot.to || slot.end_time || "";
          if (from && to) return `${from} - ${to}`;
          return from || to || "";
        })
        .filter(Boolean)
        .join(" | ");

      return slots ? `${dayLabel}: ${slots}` : dayLabel;
    })
    .filter(Boolean);
}

export function buildSocialLinks(links = {}, t) {
  return [
    {
      key: "facebook",
      label: t("PLACEHOLDERS.facebook"),
      value: links.facebook,
      icon: "fab fa-facebook-f",
      brandClass: "is-facebook",
    },
    {
      key: "instagram",
      label: t("PLACEHOLDERS.instagram"),
      value: links.instagram,
      icon: "fab fa-instagram",
      brandClass: "is-instagram",
    },
    {
      key: "snapchat",
      label: t("PLACEHOLDERS.snapchat"),
      value: links.snapchat,
      icon: "fab fa-snapchat-ghost",
      brandClass: "is-snapchat",
    },
    {
      key: "x",
      label: t("PLACEHOLDERS.twitter_link"),
      value: links.x,
      icon: "fab fa-twitter",
      brandClass: "is-twitter",
    },
    {
      key: "tiktok",
      label: t("PLACEHOLDERS.tiktok"),
      value: links.tiktok,
      icon: "fab fa-tiktok",
      brandClass: "is-tiktok",
    },
  ];
}
